import { useEffect, useState } from 'react'

/** The current time in ms, refreshed every minute so a screen that compares "now"
 *  against a window edge (or a day boundary) re-renders when the edge passes,
 *  even when no data changed. */
export function useMinuteClock(): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000)
    return () => clearInterval(id)
  }, [])
  return now
}
